import React, { useCallback, useEffect, useRef } from "react";
import { Body, Header, Modal, ModalContent, Overlay } from "./styled";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import { useDispatch, useSelector } from "react-redux";
import {
  closeModal,
  getZIndex,
  selectIsOpen,
} from "../../redux/Slice/modalSlice";
import { modalState } from "../../utils/constants";
import { CSSTransition } from "react-transition-group";
import { CSS_TRANSITION_TIMEOUT } from "../Header/Header";
import Typography from "../Typography";
import IconButton from "../IconButton";
import { Xmark } from "../Auth/assets/Xmark";
import { Button } from "../Button/Button";
import { logoutApi } from "../../redux/Slice/authSlice";

const ConfirmExitModal = () => {
  const isOpen = useSelector(selectIsOpen(modalState.CONFIRM_EXIT));
  const zIndex = useSelector(getZIndex);
  const ref = useRef();
  const dispatch = useDispatch();

  const originalOverflowRef = useRef(null);

  const closeModalHandler = useCallback(() => {
    dispatch(closeModal(modalState.CONFIRM_EXIT));
  }, [dispatch]);

  useOnClickOutside(ref, closeModalHandler);

  useEffect(() => {
    const rootEl = document.getElementById("root");

    if (rootEl && isOpen) {
      originalOverflowRef.current = rootEl.style.overflowY;
      rootEl.style.overflowY = "hidden";
    }

    return () => {
      rootEl.style.overflowY = originalOverflowRef.current;
    };
  }, [isOpen]);

  const logOutHandler = () => {
    dispatch(logoutApi());
    dispatch(closeModal());
  };

  return (
    <>
      <CSSTransition
        in={isOpen}
        timeout={CSS_TRANSITION_TIMEOUT}
        classNames="blackPage"
        unmountOnExit
      >
        <Overlay $zIndex={zIndex} />
      </CSSTransition>

      <CSSTransition
        in={isOpen}
        timeout={CSS_TRANSITION_TIMEOUT}
        classNames="alert"
        unmountOnExit
      >
        <Modal $zIndex={zIndex}>
          <ModalContent ref={ref}>
            <Header>
              <Typography variant="h2" color="primary">
                Вы уверены, что хотите выйти?
              </Typography>
              <IconButton onClick={closeModalHandler}>
                <Xmark />
              </IconButton>
            </Header>
            <Body>
              <Button variant="grey" onClick={closeModalHandler}>
                Отменить
              </Button>
              <Button variant="orange" onClick={logOutHandler}>
                Выйти
              </Button>
            </Body>
          </ModalContent>
        </Modal>
      </CSSTransition>
    </>
  );
};

export default ConfirmExitModal;
